import { Grid, Dialog, DialogTitle, DialogContent, IconButton, Divider, Tooltip, Typography } from '@mui/material';
import { List, ListItem, ListItemText } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { usersApiKeyStore } from '../../../api/users-api-key-store';
import { SkeletonIndicator } from '../../../components/skeleton-indicator.component';

interface SkillSetDialogProps {
  employeeID: number;
  isOpen: boolean;
  onCloseClick: () => void;
}

export const SkillSetDialog = ({ employeeID, isOpen, onCloseClick }: SkillSetDialogProps) => {
  const { isLoading, data } = useLoadData<ApiResponse<any>>(
    usersApiKeyStore.getUserSkillSets(employeeID) // ToDo update this with projects api endpoint
  );

  return (
    <Dialog
      open={isOpen}
      fullWidth={true}
      maxWidth={'md'}
      // onClose={onCloseClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{`SKILL SETS`}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCloseClick}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers className="popupDilog">
        <SkeletonIndicator isLoading={isLoading} count={3} variant="h4" />
        <List sx={{ width: '100%', maxHeight: '500px' }}>
          {data &&
            data.data.map((item: any, index: any) => (
              <>
                <ListItem key={`${item.skillsetID}-${item.skillsetName}`}>
                  <ListItemText
                    primary={
                      <Grid container direction="row" spacing={2}>
                        <Grid item>{index + 1}</Grid>
                        <Grid item>{item.skillsetName}</Grid>
                      </Grid>
                    }
                  />
                </ListItem>
                <Divider />
              </>
            ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};
